import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 平台 Tab 占位数量：TikTok / Meta / Google */
const PLATFORM_TAB_COUNT = 3;

/**
 * 媒体素材库页面骨架。
 *
 * 真实结构：`w-full h-full space-y-4`（此处用 `flex flex-col gap-4`，间距同为 16px，
 * 但能让卡片 `max-h-full` 按「容器高 - 工具栏高」生效，避免溢出）
 * → 工具栏（左：平台 Tab `w-53.25 h-10.5`；右：日期范围 `w-60` + 列表-网格切换）
 * → `TableCardLayout`（带层级 Tab 头，17 列）。
 */
export function MediaResourceLibrarySkeleton() {
  return (
    <div className="w-full h-full flex flex-col gap-4">
      {/* 平台切换 + 日期范围 + 列表/网格切换 */}
      <div className="flex items-center justify-between">
        <div className="flex h-10.5 w-53.25 items-center gap-1 rounded-md bg-[#F1F5F9] dark:bg-[#171717] p-1.25">
          {Array.from({ length: PLATFORM_TAB_COUNT }, (_, index) => (
            <Skeleton key={index} className="h-8 flex-1 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-60" />
          <div className="flex h-auto items-center gap-1 rounded-md bg-muted p-1.25">
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          </div>
        </div>
      </div>

      {/* 媒体素材列表卡片（实测 18 列：勾选 + 预览/素材名称/视频ID/所属账户/尺寸/时长/消耗/平均点击成本/千次展示成本/点击率/点击量/展示量/关联广告数/创建时间/标签/审核地区/审核状态） */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <ListPageSkeleton withHeaderTabs columnCount={18} />
      </div>
    </div>
  );
}

export default MediaResourceLibrarySkeleton;
